import React, { Component } from 'react';
import API from '../../../utils/API';

import BasicSectionHeader from '../../../components/views/BasicSectionHeader';
import TabsContainer from '../../../components/views/TabsContainer';
import InputField from '../../../components/inputs/inputField';
import CodeEditor from '../../../components/codeEditor/codeEditor';
import SelectField from '../../../components/inputs/selectField';
import ColorField from '../../../components/inputs/colorField';
import SectionHeader from '../../../components/views/SectionHeader';
class EventSettings extends Component {
	constructor(props) {
		super(props);
		const pages = props.program.eventDefaults.pages;
		const sessions = props.program.eventDefaults.sessions;

		const publicPathOptions = pages
			.map((po) => {
				if (po.openToPublic) return { label: po.title, value: po.pathSlug };
			})
			.filter((p) => !!p);
		const privatePathOptions = [
			...pages.map((po) => {
				return { label: po.title, value: po.pathSlug };
			}),
			...sessions.map((s) => {
				return { label: `Session: ${s.name}`, value: `session/${s.slug}` };
			})
		];
		this.state = {
			selectedSection: 0,
			organization: {},
			editedBranding: { ...props.event.branding },
			editedStyling: props.event.customCSS,
			defaultPublicPath: props.event.defaultPublicPath,
			defaultUserPath: props.event.defaultUserPath,
			loading: true,
			editing: false,
			requiredFields: {},
			publicPathOptions,
			privatePathOptions
		};
	}

	componentDidMount() {
		const { orgId } = this.props;
		API().get(`Organizations/${orgId}/account`).then((res) => {
			if (res.data) {
				this.setState({ organization: res.data, loading: false });
			}
		});
	}

	updateBranding = (property, value) => {
		const editedBranding = this.state.editedBranding;
		editedBranding[property] = value;
		this.setState({ editedBranding: editedBranding, editing: true });
	};

	updateStyling = (styling) => {
		this.setState({ editedStyling: styling, editing: true });
	};

	updateDefaultUserPath = (path) => {
		this.setState({ defaultUserPath: path, editing: true });
	};

	updateDefaultPublicPath = (path) => {
		this.setState({ defaultPublicPath: path, editing: true });
	};

	saveInfo = () => {
		const { editedBranding, editedStyling, defaultPublicPath, defaultUserPath } = this.state;
		this.setState({ saving: true });
		this.props.saveDetails(
			{
				...this.props.event,
				branding: editedBranding,
				customCSS: editedStyling,
				defaultPublicPath: defaultPublicPath,
				defaultUserPath: defaultUserPath
			},
			() => {
				this.setState({ editing: false, saving: false, error: '' });
			}
		);
	};

	cancelEdit = () => {
		const { branding, customCSS, defaultPublicPath, defaultUserPath } = this.props.event;

		this.setState({
			editedBranding: branding,
			editing: false,
			editedStyling: customCSS,
			defaultPublicPath: defaultPublicPath,
			defaultUserPath: defaultUserPath
		});
	};

	SectionItem = (title, sectionNo) => {
		return (
			<div
				className={`sectionTab ${sectionNo === this.state.selectedSection ? 'selected' : ''}`}
				onClick={() => {
					this.setState({ selectedSection: sectionNo });
				}}
			>
				<div className="calibreBold fs-30">{title}</div>
			</div>
		);
	};

	updateSelected = (selectedIndex) => {
		this.setState({ selectedSection: selectedIndex });
	};

	renderSection = () => {
		const {
			organization,
			editedBranding,
			selectedSection,
			editedStyling,
			defaultPublicPath,
			defaultUserPath,
			requiredFields
		} = this.state;
		const { readOnly } = this.props;
		switch (selectedSection) {
			case 0:
				const { publicPathOptions, privatePathOptions } = this.state;
				const publicPath = publicPathOptions.find((path) => path.value == defaultPublicPath);
				const privatePath = privatePathOptions.find((path) => path.value == defaultUserPath);
				return (
					<div className="sectionBlock">
						<SelectField
							label="Public Home Page"
							value={publicPath ? publicPath : { label: '', value: '' }}
							name="defaultUserPath"
							disabled={readOnly}
							options={publicPathOptions}
							onChange={(path) => {
								this.setState({ publicPath: path });
								this.updateDefaultPublicPath(path.value);
							}}
						/>
						<SelectField
							label="Private Home Page"
							disabled={readOnly}
							value={privatePath ? privatePath : { label: '', value: '' }}
							name="defaultUserPath"
							options={privatePathOptions}
							onChange={(path) => {
								this.setState({ privatePath: path });
								this.updateDefaultUserPath(path.value);
							}}
						/>
					</div>
				);

			case 1:
				return (
					<div className="sectionBlock">
						<h2 className="blockHeader">Images</h2>
						<InputField
							label="Logo"
							value={
								!editedBranding.logo || editedBranding.logo === '' ? (
									''
								) : (
									editedBranding.logo
								)
							}
							placeholder={organization.branding.logo}
							disabled={readOnly}
							type="text"
							onChange={(e) => this.updateBranding('logo', e.target.value)}
						/>
						<InputField
							label="Website Icon"
							value={
								!editedBranding.favicon || editedBranding.favicon === '' ? (
									''
								) : (
									editedBranding.favicon
								)
							}
							placeholder={organization.branding.favicon}
							disabled={readOnly}
							type="text"
							onChange={(e) => this.updateBranding('favicon', e.target.value)}
						/>
						<div className="sectionSubtitle">Colors</div>
						<ColorField
							label="Primary Color"
							value={
								!editedBranding.accentColor || editedBranding.accentColor === '' ? (
									organization.branding.accentColor
								) : (
									editedBranding.accentColor
								)
							}
							disabled={readOnly}
							type="text"
							onChange={(e) => this.updateBranding('accentColor', e.target.value)}
						/>
						<ColorField
							label="Primary Text Color"
							value={
								!editedBranding.fontColor || editedBranding.fontColor === '' ? (
									organization.branding.fontColor
								) : (
									editedBranding.fontColor
								)
							}
							disabled={readOnly}
							type="text"
							onChange={(e) => this.updateBranding('fontColor', e.target.value)}
						/>
					</div>
				);
			case 2:
				return '';
			case 3:
				return (
					<CodeEditor
						content={editedStyling}
						language="css"
						disabled={readOnly}
						setContent={this.updateStyling}
					/>
				);
		}
	};

	render() {
		const { editing, loading, selectedSection } = this.state;
		const { program } = this.props;
		console.log('path', this.state.privatePathOptions);
		return (
			<div className="sectionContainer">
				<SectionHeader
					editing={editing}
					cancelEdit={this.cancelEdit}
					saveEdit={this.saveInfo}
					updatedAt={program.updatedAt}
					title={'Default Event Preferences'}
					description={
						'Set your website homepage, customize your event theme, and more for all approved events.'
					}
					breadcrumbs={[
						{
							name: program.name
						}
					]}
				>
					<TabsContainer
						tabs={[
							{ title: 'Settings' },
							{ title: 'Branding' },
							{ title: 'Typography' },
							{ title: 'Custom Styling' }
						]}
						updateSelected={this.updateSelected}
						selectedIndex={selectedSection}
					/></SectionHeader>

				<div className="sectionBody">{!loading && this.renderSection()}</div>
			</div>
		);
	}
}

export default EventSettings;
